/**
 * Created by Christof Sander on 21.07.2016.
 */

/////////////////////////////////////
/// REQUIRE PACKAGES
/////////////////////////////////////

	var appConfig               = require('../lib/config').getConfig();
	window.$ = window.jQuery    = require('jquery');
	window.ClientError          = require('./error');
	require('./errorHandler');
	// TODO: get rid of this one
	if(appConfig.bindTouchableEvents){
		require('jquery-mobile-events');
	}
	var utils         = require('../lib/utils');
	utils.i18next.init(appConfig.i18next);
	window.__ = utils.i18next.__;
	var componentList   = require('./componentList');
	// TODO: turn this on if mobile testing is your thing and web-developer is not available
	require('./debugConsole')(appConfig, componentList, window.$);
	var Component       = require('../lib/component');
	var store           = require('./store');
	store.init();
	var storage         = store.get();
	var componentTree   = storage.componentTree;
	var validator       = require('./validator');
	const etagResourceHandler   = require('../client/etagResourceHandler');




/////////////////////////////////////
/// INIT APP
/////////////////////////////////////

	/**
	 * this function is used to get a component according to a dom-element, a jquery dom-element or an index within the lookup table
	 *
	 * @param   element     	number (index) | object DOM-Element | $ jQuery-DOM-Element
	 * @param   ignoreErrors	boolean - prevent not found error from being thrown
	 * @returns Component | void in an error case
	 */
	window.getComponent = function(element, ignoreErrors){
		// jquery- or dom-object
		if(typeof(element) === 'object'){
			// dom object?
			if(typeof(element.nodeName) !== 'undefined') element = $(element);
			// jquery object?
			if((element instanceof $)){
				var componentIndex = element.data('componentIndex');
				if(typeof(componentIndex) !== 'undefined'){
					return componentTree.lookup[componentIndex];
				}
			}
		}
		// lookup in component tree
		else if(utils.isNumber(element) || utils.isString(element)){
			return componentTree.lookup[element];
		}

		if(!ignoreErrors) throw new Error('Component not found');
	};

	$(document)
		.ready(function(){
			// set root route of the actual load request
			window.rootRoute = window.route;

			// set base headers for all requests
			$.ajaxSetup({
				contentType:        "application/json; charset=utf-8",
				dataType:"json",
				headers: {
					Accept:             "application/json; charset=utf-8",
					'fec_root_route':   window.route,
					'fec_base_route':   window.route,
					'fec_full_route':   window.fullRoute
				}
			});

			// update client storage if necessary
			if(window.updateClientStorage){
				if(window.updateClientStorage.session && window.updateClientStorage.session.user && storage.user && utils.isFunction(storage.user.reset)){
					storage.user.reset();
				}
				storage = store.set(window.updateClientStorage, undefined, undefined, undefined, undefined, false);
			}

			// set i18next lang just in case the user language has been changed (and last but not least initially)
			if(storage.user.data.langCode && utils.i18next.initialized){
				utils.i18next.core.changeLanguage(storage.user.data.langCode);
			}

			// init validators if necessary
			if(storage.app && storage.app.validators && storage.app.validators.data){
				validator.initValidators(storage.app.validators.data);
			}

			// print viewMode
			var sco;
			if((sco = (((storage || {}).user || {}).data || {}).serviceCollectionOptions)){
				console.log('### INIT - ServiceCollectionOptions:', sco);
			}

			// prepare globals
			window.componentTree = componentTree;
			window.componentList = componentList;
			window.storage = storage;
			window.store = store;
			window.etagResourceHandler = etagResourceHandler;

			// build component tree
			componentTree.build(window.route, window.tree, true, true, true, storage, {}, undefined, {}, undefined, {});

			// add errorParent component to componentTree
			componentTree.lookup.errorParent = new Component({ component: ['collection'], componentIndex: 'errorParent' }, appConfig.requestIDFallback, appConfig.sessionIDFallback, appConfig.serviceDomainFallback);

			// cleanup
			window.tree = {};
			// TODO: NEEDED?

			if(!window.routeParams){
				window.routeParams = {};
			}

			var $dynamicJSSources;
			if(($dynamicJSSources = $('script.dynamicJSSources')).length > 0){
				$dynamicJSSources.remove();
			}

			// attach component tree to dom
			componentTree.trigger(undefined, 'attach', {}, true);
		})
	;
